import axios from "axios";

export const deleteRoleById = async (id) => {
  try {
    const response = await axios.delete(`http://localhost:8080/webnet-hms/api/roles/${id}`);
    window.alert("Roles deleted successfully!");
    return response.data;
  } catch (error) {
    console.error("Error deleting Roles:", error);
    window.alert("Failed to delete Roles.");
  }
};
